export const SqlEditorConstants = {
    RUN_SCRIPT_REQUEST: 'RUN_SCRIPT_REQUEST',
    RUN_SCRIPT_SUCCESS: 'RUN_SCRIPT_SUCCESS',
    RUN_SCRIPT_FAILURE: 'RUN_SCRIPT_FAILURE',
};